import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiPaginateDirective } from './ui-paginate.directive';
import { IonicModule } from '@ionic/angular';
import { UiEmptyBoxComponent } from '@bling-fe/shared/ui-components/ui-empty-box';
import { UiErrorBoxComponent } from '@bling-fe/shared/ui-components/ui-error-box';
import { UiSkeletonComponent } from '@bling-fe/shared/ui-components/ui-skeleton';
import { UiInfinitePaginationComponent } from './ui-infinite-pagination.component';

@NgModule({
  declarations: [UiInfinitePaginationComponent, UiPaginateDirective],
  imports: [
    CommonModule,
    IonicModule,
    UiErrorBoxComponent,
    UiEmptyBoxComponent,
    UiSkeletonComponent
  ],
  exports: [
    UiInfinitePaginationComponent,
    UiPaginateDirective,
    UiErrorBoxComponent,
    UiEmptyBoxComponent,
    UiSkeletonComponent
  ]
})
export class UiInfinitePaginationModule {}
